import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Spinner } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import LocationList from '../LocationList/LocationList.js';

const LocationSearchList = (_param)=>{
    var { children , className , loading  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "loading"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('location-search-list', className)
    }), loading ? /*#__PURE__*/ React.createElement("div", {
        className: "location-search-list__loader"
    }, /*#__PURE__*/ React.createElement(Spinner, {
        "aria-label": getLabel('common.loadingText')
    })) : /*#__PURE__*/ React.createElement(LocationList, null, children));
};

export { LocationSearchList as default };
//# sourceMappingURL=LocationSearchList.js.map
